import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Module} from '../interface/module';
import {environment} from '../../../../environments/environment';
import {Payment} from '../../others/interface/payment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private httpClient: HttpClient) { }

  getCollection(): Observable<Module[]>{
    return this.httpClient.get<Module[]>(`${this.baseUrl}/get/modules`);
  }
  getEnableCollection(): Observable<Module[]>{
    return this.httpClient.get<Module[]>(`${this.baseUrl}/get/enable/modules`);
  }

  post(data: Module): Observable<any>{
    return this.httpClient.post<Module>(`${this.baseUrl}/create/module`, data);
  }

  put(id: number, data: Module): Observable<any>{
    return this.httpClient.put<Module>(`${this.baseUrl}/edit/module/${id}`, data);
  }

  delete(id: number): Observable<Module>{
    return this.httpClient.delete<Module>(`${this.baseUrl}/delete/module/` + id);
  }

  getUserModuleList(): Observable<Payment[]>{
    return this.httpClient.get<Payment[]>(`${this.baseUrl}/user/modules`);
  }

  deleteMultipleModule(ids: number[]): Observable<Module[]>{
    const options = {body: ids};
    return this.httpClient.delete<Module[]>(`${this.baseUrl}/delete/selected/modules`, options);
  }
}
